var map = {
	"./0101.jpg": 3333,
	"./0102.jpg": 2346,
	"./0103.jpg": 4999,
	"./0104.jpg": 7564,
	"./0105.jpg": 4937,
	"./0167.jpg": 6629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7690;